import { Image } from '../Image';
import { Text } from '../Text';

export interface TextImageProps {
  heading: string;
  caption: string;
  body: string;
  picture: any;
}

export const TextImage = ({
  heading,
  caption,
  body,
  picture,
  ...rest
}: TextImageProps) => {
  const props = {
    body: `<h3>${heading}</h3><h6>${caption}</h6>${body}`,
  };

  return (
    <>
      <Image image={picture} alt="" />
      <Text {...props} />
    </>
  );
};

TextImage.defaultProps = {
  heading: '',
  caption: '',
  body: '',
} as Partial<TextImageProps>;
